<h1 mat-dialog-title>{{'Documentazione tipologie risorsa' | translate}}</h1>
<mat-dialog-content>

	<div class="behavior-section">
		<h3>{{'Tipologie con comportamento speciale' | translate}}</h3>
		<span class="behavior-badge">{{'Attivano comportamenti particolari' | translate}}</span>

		<div class="sub-type-item">
			<span class="sub-type-code">PICKUP</span>
			<span class="sub-type-label">{{'Pick-up' | translate}}</span>
			<p class="sub-type-desc">{{'Permette di impostare una lista di punti di ritrovo che verrà presentata come scelta in fase di prenotazione.' | translate}}</p>
		</div>

		<div class="sub-type-item">
			<span class="sub-type-code">OPTS</span>
			<span class="sub-type-label">{{'Options (Selezione multipla)' | translate}}</span>
			<p class="sub-type-desc">{{'Permette di configurare risorse figlie come opzioni selezionabili in un menu a tendina. Richiede la configurazione di un\'opzione primaria di default. In fase di prenotazione, l\'utente sceglie tra le opzioni disponibili.' | translate}}</p>
		</div>

		<div class="sub-type-item">
			<span class="sub-type-code">CINT</span>
			<span class="sub-type-label">{{'Custom Inputs' | translate}}</span>
			<p class="sub-type-desc">{{'Genera un form dinamico con campi di input personalizzabili. La risorsa viene attivata automaticamente in fase di prenotazione (non opzionale). Ogni input puo avere tipo, label multilingue, valori min/max.' | translate}}</p>
		</div>

		<div class="sub-type-item">
			<span class="sub-type-code">BAR</span>
			<span class="sub-type-label">{{'Barca' | translate}}</span>
			<p class="sub-type-desc">{{'Risorsa utilizzata per la gestione di imbarcazioni con la possibilità di specificare campi personalizzati' | translate}}</p>
		</div>

		<div class="sub-type-item">
			<span class="sub-type-code">AUDIOGUIDA</span>
			<span class="sub-type-label">{{'Audioguida' | translate}}</span>
			<p class="sub-type-desc">{{'Accetta esclusivamente file audio in formato MP3. Traccia la durata in secondi di ogni file audio' | translate}}</p>
		</div>

		<div class="sub-type-item">
			<span class="sub-type-code">TICKETPDF</span>
			<span class="sub-type-label">{{'Biglietto PDF' | translate}}</span>
			<p class="sub-type-desc">{{'Gestisce biglietti in formato PDF con tracciamento dei download. I file vengono inclusi automaticamente nel download del voucher della prenotazione.' | translate}}</p>
		</div>

		<div class="sub-type-item">
			<span class="sub-type-code">TICKETTXT</span>
			<span class="sub-type-label">{{'Biglietto Testo' | translate}}</span>
			<p class="sub-type-desc">{{'Mostra un campo aggiuntivo "Testo da allegare al biglietto" nel form di creazione. Il testo viene utilizzato nelle email di notifica della prenotazione.' | translate}}</p>
		</div>

		<div class="sub-type-item">
			<span class="sub-type-code">FILE</span>
			<span class="sub-type-label">{{'PDF/IMG' | translate}}</span>
			<p class="sub-type-desc">{{'File PDF o immagine che viene allegato automaticamente alle email di notifica della prenotazione e incluso nel download del voucher.' | translate}}</p>
		</div>
	</div>

	<h3>{{'Tipologie biglietti' | translate}}</h3>
	<mat-divider></mat-divider>

	<div class="sub-type-item">
		<span class="sub-type-code">TICKET</span>
		<span class="sub-type-label">{{'Biglietto' | translate}}</span>
		<p class="sub-type-desc">{{'Tipo biglietto generico. Utilizzato come riferimento per le notifiche email delle prenotazioni.' | translate}}</p>
	</div>

	<mat-divider></mat-divider>
	<h3>{{'Tipologie trasporto' | translate}}</h3>
	<mat-divider></mat-divider>

	<div class="sub-type-item">
		<span class="sub-type-code">BUS</span>
		<span class="sub-type-label">{{'Bus' | translate}}</span>
		<p class="sub-type-desc">{{'Pullman standard.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">BUSD</span>
		<span class="sub-type-label">{{'Bus Doppio' | translate}}</span>
		<p class="sub-type-desc">{{'Pullman a due piani.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">BUSEX</span>
		<span class="sub-type-label">{{'Bus Escursioni' | translate}}</span>
		<p class="sub-type-desc">{{'Pullman dedicato alle escursioni.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">BUSPT</span>
		<span class="sub-type-label">{{'Bus Programmi Tour Operator' | translate}}</span>
		<p class="sub-type-desc">{{'Pullman per programmi tour operator.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">BUSLT</span>
		<span class="sub-type-label">{{'Bus Programmi Tour Operator' | translate}}</span>
		<p class="sub-type-desc">{{'Pullman per programmi tour operator (variante).' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">BUSGEN</span>
		<span class="sub-type-label">{{'Bus Generico per Linee' | translate}}</span>
		<p class="sub-type-desc">{{'Pullman generico per servizi di linea.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">NVT</span>
		<span class="sub-type-label">{{'Navetta' | translate}}</span>
		<p class="sub-type-desc">{{'Servizio navetta per trasferimenti senza punto di ritrovo obbligatorio.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">TRE</span>
		<span class="sub-type-label">{{'Treno' | translate}}</span>
		<p class="sub-type-desc">{{'Servizio ferroviario.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">TRB</span>
		<span class="sub-type-label">{{'Trasporto Bagagli' | translate}}</span>
		<p class="sub-type-desc">{{'Servizio di trasporto bagagli.' | translate}}</p>
	</div>

	<mat-divider></mat-divider>
	<h3>{{'Tipologie personale' | translate}}</h3>
	<mat-divider></mat-divider>

	<div class="sub-type-item">
		<span class="sub-type-code">GUI</span>
		<span class="sub-type-label">{{'Guida Turistica' | translate}}</span>
		<p class="sub-type-desc">{{'Risorsa per guide turistiche, permette l\'assegnazione a elementi dello staff nei pacchetti.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">ACC</span>
		<span class="sub-type-label">{{'Accompagnatore' | translate}}</span>
		<p class="sub-type-desc">{{'Risorsa per accompagnatori di viaggio.' | translate}}</p>
	</div>

	<mat-divider></mat-divider>
	<h3>{{'Tipologie economiche' | translate}}</h3>
	<mat-divider></mat-divider>

	<div class="sub-type-item">
		<span class="sub-type-code">ASS</span>
		<span class="sub-type-label">{{'Assicurazione Medico e Bagaglio' | translate}}</span>
		<p class="sub-type-desc">{{'Copertura assicurativa per spese mediche e smarrimento bagagli.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">ANN</span>
		<span class="sub-type-label">{{'Assicurazione Annullamento' | translate}}</span>
		<p class="sub-type-desc">{{'Copertura assicurativa per annullamento del viaggio.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">PEN</span>
		<span class="sub-type-label">{{'Penale Annullamento' | translate}}</span>
		<p class="sub-type-desc">{{'Gestione delle penali per annullamento prenotazione.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">PKG</span>
		<span class="sub-type-label">{{'Pacchetto Servizi' | translate}}</span>
		<p class="sub-type-desc">{{'Raggruppamento di piu servizi in un unico pacchetto.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">RID</span>
		<span class="sub-type-label">{{'Riduzione' | translate}}</span>
		<p class="sub-type-desc">{{'Applicazione di riduzioni sul prezzo.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">SPS</span>
		<span class="sub-type-label">{{'Supplemento Singola' | translate}}</span>
		<p class="sub-type-desc">{{'Supplemento per camera singola in strutture alberghiere.' | translate}}</p>
	</div>

	<mat-divider></mat-divider>
	<h3>{{'Altre tipologie' | translate}}</h3>
	<mat-divider></mat-divider>

	<div class="sub-type-item">
		<span class="sub-type-code">NAV</span>
		<span class="sub-type-label">{{'Navigazione' | translate}}</span>
		<p class="sub-type-desc">{{'Servizio di navigazione.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">ING</span>
		<span class="sub-type-label">{{'Ingressi' | translate}}</span>
		<p class="sub-type-desc">{{'Biglietti di ingresso a musei, attrazioni, ecc.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">SPE</span>
		<span class="sub-type-label">{{'Spettacoli e Attivita' | translate}}</span>
		<p class="sub-type-desc">{{'Spettacoli, eventi e attivita varie.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">RAD</span>
		<span class="sub-type-label">{{'Radioguide' | translate}}</span>
		<p class="sub-type-desc">{{'Servizio di radioguide.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">REG</span>
		<span class="sub-type-label">{{'Regalone' | translate}}</span>
		<p class="sub-type-desc">{{'Omaggio o regalo incluso nel pacchetto.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">GAD</span>
		<span class="sub-type-label">{{'Gadgets e Abbigliamento' | translate}}</span>
		<p class="sub-type-desc">{{'Gadgets, merchandising e abbigliamento.' | translate}}</p>
	</div>

	<div class="sub-type-item">
		<span class="sub-type-code">LIB</span>
		<span class="sub-type-label">{{'Libri e Guide Turistiche' | translate}}</span>
		<p class="sub-type-desc">{{'Libri, guide turistiche e materiale informativo.' | translate}}</p>
	</div>

</mat-dialog-content>
<mat-dialog-actions align='end'>
	<button mat-flat-button (click)='onYesClick()' color='accent'>{{'Chiudi' | translate}}</button>
</mat-dialog-actions>
